module.exports = __webpack_public_path__ + "img/standard_active_mobile.8060cfbd.png";